import React from "react";
import feature1 from "../assets/images/fea1.png";
import feature2 from "../assets/images/fea2.png";
import feature3 from "../assets/images/fea3.png";
import feature4 from "../assets/images/fea4.png";

const features = [
  {
    title: "Say Anything",
    description:
      "Easily share text, voice messages, photos,<br/> videos, GIFs, and files for free.",
    imgSrc: feature1,
  },
  {
    title: "Chat Freely",
    description:
      "Experience messaging with a fresh focus on<br/> privacy and all the features you love.",
    imgSrc: feature2,
  },
  {
    title: "Chat Securely, Chat Freely",
    description:
      "Messages are secured with end-to-end encryption,<br/> accessible only to you and the recipient.",
    imgSrc: feature3,
  },
  {
    title: "Get Together with Groups",
    description:
      "Group chats make it easy to stay connected to<br/> your family, friends, and coworkers.",
    imgSrc: feature4,
  },
];

const Features = () => {
  return (
    <div className="px-8 lg:px-32 xl:px-52">
      <h2 className="text-center text-2xl lg:text-3xl font-bold mb-5 mt-14">App Features</h2>
      <div className="container mx-auto px-5 py-8">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-8 sm:grid-cols-2">
          {features.map((feature, index) => (
            <div
              key={index}
              className="bg-[#F3F3F3] shadow-lg rounded-lg p-6 border hover:shadow-[0_4px_10px_#0AA65B]  transition-shadow duration-300"
            >
              <div className="flex justify-center mb-6">
                <img
                  src={feature.imgSrc}
                  alt={feature.title}
                  className="object-contain h-[230px] features-img"
                />
              </div>
              <h3 className="text-[20px] font-semibold text-center mb-4 text-[#0AA65B]">{feature.title}</h3>
              <p
                className="text-[#222222] text-center text-[14px]"
                dangerouslySetInnerHTML={{ __html: feature.description }}
              />
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default Features;
